module.exports = __webpack_public_path__ + "static/media/Personalized.16e5ebc1.webp";